import React from 'react'

const PriceInput = React.forwardRef((props, ref) => (
  <label className='league-label'>
    {props.label}
    <span className='price-sign'>$</span>
    <input className='league-control price-input' {...props} min='0' step='0.01' type='number' ref={ref} />
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default PriceInput
